<template>
  <div class="relative inline-block" id="website-menu-container">
    <button
      class="w-full flex flex-row justify-between items-center md:pb-2 text-blueGray-600 mr-0 whitespace-nowrap text-sm uppercase font-bold tracking-wider p-4 px-0"
      @click="() => (opened = true)"
      type="button"
      id="options-menu"
      aria-expanded="true"
      aria-haspopup="true"
    >
      {{ title }}
      <!-- Heroicon name: solid/chevron-down -->
      <svg
        class="h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <div
      v-click-outside="handleClose"
      v-if="opened"
      class="absolute mt-2 w-52 -left-4 z-50 rounded shadow-lg bg-white text-base"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-2" role="none">
        <div v-for="(link, index) in links" :key="index">
          <a
            :href="link.link"
            class="py-2 px-4 block w-full bg-transparent text-xs uppercase font-medium tracking-wider text-blueGray-700 hover:text-blueGray-500"
            role="menuitem"
            ><span v-html="link.icon" class="mr-2"></span>{{ link.title }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebsiteSelector",
  props: {
    title: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      opened: false
    };
  },
  directives: {
    "click-outside": {
      mounted(el, { value: closeFunction }) {
        window.addEventListener("click", closeFunction);
      },
      unmounted(el, { value: closeFunction }) {
        window.removeEventListener("click", closeFunction);
      }
    }
  },
  methods: {
    handleClose() {
      if (this.opened) {
        if (
          !document
            .getElementById("website-menu-container")
            .contains(window.event.target)
        ) {
          this.opened = false;
        }
      } else {
        this.opened = true;
      }
    }
  }
};
</script>
